var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 405.333 405.333",
    style: {
      enableBackground: "new 0 0 405.333 405.333"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0,309.333 42.667,309.333 42.667,320 21.333,320 21.333,341.333 42.667,341.333 42.667,352 0,352 0,373.333  64,373.333 64,288 0,288  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.333,117.333 42.667,117.333 42.667,32 0,32 0,53.333 21.333,53.333  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,181.333 38.4,181.333 0,226.133 0,245.333 64,245.333 64,224 25.6,224 64,179.2 64,160 0,160  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.667,
    y: 309.333,
    width: 298.667,
    height: 42.667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.667,
    y: 53.333,
    width: 298.667,
    height: 42.667
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.667,
    y: 181.333,
    width: 298.667,
    height: 42.667
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedList);
export default __webpack_public_path__ + "static/media/ordered-list.fadab904ca5bc567441528dc4fee0e17.svg";
export { ForwardRef as ReactComponent };